import { useContext } from "react";

import { useFlippers } from "@shared/context/FlippersContext";
import { GlobalContext, GlobalContextUserRole } from "@shared/context/GlobalConfig";

const useIsPatientDarkModeDisabled = (): boolean => {
  const [isDarkModeFlipperEnabled] = useFlippers("dora_disable_patient_dark_mode");
  const { role } = useContext(GlobalContext);

  return role === GlobalContextUserRole.PATIENT && isDarkModeFlipperEnabled;
};

export { useIsPatientDarkModeDisabled };
